module.exports = __webpack_public_path__ + "static/media/iitpLogo.44dd5cbe.png";